import React, { PureComponent } from "react";
import { Row, Col, Input, Modal } from "antd";
import {
  Form,
  Select,
  Upload,
  Message,
  Table,
  Button,
  Radio,
  DatePicker,
  Rate,
} from "element-react";
import { getToken, getCurrentUser, getUserId } from "utils/storage";
import "./index.scss";
import FeatureBanner from "components/FeatureBanner";
import { Link, Router } from "react-router-dom";
import Navigation from "../../components/navigation";
import Request from "../../networkReq/request";
import Http from "../../networkReq/http";
import moment from "moment";
import Edit from "../../images/edit.png";
import zIndex from "@material-ui/core/styles/zIndex";
const { Search, TextArea } = Input;
const FormItem = Form.Item;

export default class Index extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activekey: "basic",
      disabled: true,
      dicts: [],
      selectId: "",
      form: {
        avatar: "",
        name: "",
        householdRegistrationNature: "",
        sexName: "",
        censusRegisterDetailedAddress: "",
        age: "",
        personnelCategory: "",
        phone: "",
        // honorarytitle: '荣誉称号',
        enlistmentTime: "",
        dischargeTime: "",
        presentSituation: "",
        employmentType: "",
        householdRegistrationType: "",
        retiredSoldiersTypes: "",
        resettlementMode: "",
        resettlementWork: "",
        rank: "",
        preferentialCareObject: "",
        preferentialCareObjectType: "",
      },
      form2: {
        applicantEvaluation: "",
        applicantScore: "",
        applicantEvaluationExhibitionMode: "",
      },
      rules: {
        householdRegistrationNature: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        censusRegisterDetailedAddress: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        personnelCategory: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        honorarytitle: [
          { required: true, message: "请选择", trigger: "change" },
        ],
      },
      rules2: {
        applicantEvaluation: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        applicantScore: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        applicantEvaluationExhibitionMode: [
          { required: true, message: "请选择", trigger: "change" },
        ],
      },
      columns: [
        {
          label: "编号",
          prop: "id",
          width: 120,
        },
        {
          label: "项目名称",
          prop: "applyProjectName",
          width: 180,
        },
        {
          label: "节点",
          prop: "finalStatusName",
          width: 150,
        },
        {
          label: "办件类型",
          prop: "regCaseType",
          width: 130,
          render: (val, row) => {
            return <span>{val == 1 ? "权利运行" : "公共服务"}</span>;
          },
        },
        {
          label: "状态",
          prop: "businessStatus",
          width: 130,
        },
        {
          label: "登记时间",
          prop: "createTime",
          width: 160,
        },
        {
          label: "操作",
          prop: "id",
          width: 120,
          render: (val, row) => {
            return (
              <span>
                <Button
                  type="text"
                  size="small"
                  onClick={() => this.handleOtherDetail(val)}
                >
                  查看
                </Button>
                <Button
                  type="text"
                  size="small"
                  onClick={() => this.handleEvaluate(val)}
                >
                  评价
                </Button>
              </span>
            );
          },
        },
      ],
      processes: [],
      isdetail: false,
      details: {},

      selectindex: "1",
      setSourceName: "",
      currentIndex: 1,
      listData: [],
      userId: "",
      visible: false,
      confirmLoading: false,
    };
  }

  componentDidMount() {
    let form = this.state.form;
    const user = getCurrentUser();
    const token = getToken();
    //{ user_id: user.user_id },
    // if (!!user) {
    Http.get(Request.detailUser(), {}, (obj) => {
      if (obj.code == 200) {
        form.avatar = obj.data.avatar;
        form.name = obj.data.name;
        form.householdRegistrationNature =
          obj.data.userVeterans.householdRegistrationNature;
        form.censusRegisterDetailedAddress =
          obj.data.userVeterans.censusRegisterDetailedAddress;
        form.age = obj.data.age;
        form.sexName = obj.data.sexName;
        form.personnelCategory = obj.data.userVeterans.personnelCategory;
        form.phone = obj.data.phone;
        form.enlistmentTime = obj.data.userVeterans.enlistmentTime;
        form.dischargeTime = obj.data.userVeterans.dischargeTime;
        form.presentSituation = obj.data.userVeterans.presentSituation;
        form.employmentType = obj.data.userVeterans.employmentType;
        form.householdRegistrationType =
          obj.data.userVeterans.householdRegistrationType;
        form.retiredSoldiersTypes = obj.data.userVeterans.retiredSoldiersTypes;
        form.resettlementMode = obj.data.userVeterans.resettlementMode;
        form.resettlementWork = obj.data.userVeterans.resettlementWork;
        form.rank = obj.data.userVeterans.rank;
        form.preferentialCareObject =
          obj.data.userVeterans.preferentialCareObject;
        form.preferentialCareObjectType =
          obj.data.userVeterans.preferentialCareObjectType;
        this.setState({
          form: obj.data,
          value1: obj.data.userVeterans.enlistmentTime,
          value2: obj.data.userVeterans.dischargeTime,
        });
      }
    });
    // }
    if (user) {
      Http.postJson(
        Request.getProcessList(),
        { current: 1, size: 100000 },
        (obj) => {
          if (obj.code == 200) {
            this.setState({
              processes: obj.data.records,
            });
          }
        }
      );
    }
    Http.get(Request.get_dict(), {}, (obj) => {
      if (obj.code == 200) {
        this.setState({
          dicts: obj.data,
          userId: getUserId(),
        });
      }
    });
  }

  handleDetail = (flag, id) => {
    Http.get(Request.getComplaintDetail(), { id: id }, (obj) => {
      if (obj.code == 200) {
        this.setState({
          details: obj.data,
          isdetail: !!flag,
        });
      }
    });
  };

  handleOtherDetail = (url) => {
    console.log("urlurl:", url);
    // if (url != '') {
    //   if (url.indexOf("http") != -1 || url.indexOf("https") != -1) {
    //     window.open(url);
    //   }
    // }
  };
  handleEvaluate = (row) => {
    this.setState({
      visible: true,
      selectId: row.id,
    });
  };
  handleCancel = () => {
    // console.log('Clicked cancel button');
    this.setState({
      visible: false,
      form2: {
        applicantEvaluation: "",
        applicantScore: "",
        applicantEvaluationExhibitionMode: "",
      },
    });
  };
  handleOk = (e) => {
    const { form2, value1, value2, selectId } = this.state;
    e.preventDefault();
    console.log("form2form2form2form2", form2);
    this.refs.form2.validate((valid) => {
      if (
        form2.applicantEvaluation == "" ||
        form2.applicantEvaluationExhibitionMode == "" ||
        form2.applicantScore == ""
      ) {
        Message.error({
          message: "必填项不能为空",
          customClass: "tipsMessage",
        });
        return false;
      }

      if (valid) {
        Http.postJson(
          Request.getEvaluate(),
          {
            ...form2,
            applicantScore: form2.applicantScore.currentTarget.value,
            id: selectId,
          },
          (obj) => {
            if (obj.code == 200) {
              this.setState({
                confirmLoading: true,
              });
              setTimeout(() => {
                Message.success("评价成功");
                this.setState({
                  visible: false,
                  confirmLoading: false,
                  form2: {
                    applicantEvaluation: "",
                    applicantScore: "",
                    applicantEvaluationExhibitionMode: "",
                  },
                });
              }, 2000);
            }
          }
        );
      }

      console.log("====================================");
      console.log("dqwdqwdqwdqwdq:", form2, valid);
      console.log(form2.applicantScore.currentTarget.value);
      console.log("====================================");
    });
  };

  handleEdit = (flag) => {
    this.setState({
      disabled: false,
    });
  };

  handleAvatarScucess(res, file, key) {
    console.log("file111111111", file);
    if (file.status === "error") {
      Message.error("上传失败");
      return;
    }
    if (file.status === "success") {
      const { response } = file;
      if (response && response.code == 200) {
        Message.success("上传成功");
        const {
          data: { url },
        } = response;
        this.setState({
          form: Object.assign({}, this.state.form, { [key]: url }),
          // imageUrl: URL.createObjectURL(file.raw)
        });
      }
    }
  }

  beforeAvatarUpload(file) {
    const isJPG =
      file.type === "image/jpeg" ||
      file.type === "image/jpg" ||
      file.type === "image/png";
    const isLt2M = file.size / 1024 / 1024 < 2;

    if (!isJPG) {
      Message("格式错误，请重新上传！");
    }
    if (!isLt2M) {
      Message("上传头像图片大小不能超过 2MB!");
    }
    return isJPG && isLt2M;
  }

  handleChange = (activekey) => {
    if (activekey == "hudong") {
      this.tosearch("1", "", getUserId());
    }
    this.setState({ activekey, isdetail: false });
  };

  handleSubmit(e) {
    const { form, value1, value2 } = this.state;
    e.preventDefault();

    this.refs.form.validate((valid) => {
      if (
        form.avatar == "" ||
        form.userVeterans.householdRegistrationNature == "" ||
        form.userVeterans.censusRegisterDetailedAddress == "" ||
        form.userVeterans.personnelCategory == "" ||
        value2 == "" ||
        value1 == ""
      ) {
        Message.error("必填项不能为空");
        return false;
      }
      if (valid) {
        form.userVeterans.dischargeTime = moment(value2).format("YYYY-MM-DD");
        form.userVeterans.enlistmentTime = moment(value1).format("YYYY-MM-DD");
        Http.postJson(Request.saveUserInfo(), form, (obj) => {
          if (obj.code == 200) {
            Message.success("保存成功！");
            // this.props.history.push('/entrance/home')
            this.setState({
              form: form,
              disabled: true,
            });
            this.refs.form.resetFields();
            return;
          } else {
            Message.error(obj.msg);
            return;
          }
        });
      } else {
        console.log("error submit!!");
        return false;
      }
    });
  }

  onChange(key, value) {
    const { form } = this.state;
    let obj = form;
    console.log("form", form);
    if (
      key != "avatar" &&
      key != "name" &&
      key != "age" &&
      key != "sexName" &&
      key != "phone"
    ) {
      obj.userVeterans[key] = value;
      this.setState({
        form: Object.assign({}, obj),
      });
    } else {
      this.setState({
        form: Object.assign({}, this.state.form, { [key]: value }),
      });
    }
  }

  // 查询列表
  tosearch(index, val, uId) {
    const { dispatch } = this.props;

    switch (index) {
      case "1": //厅长信箱
        Http.get(
          Request.directormailboxLList(),
          { current: 1, size: 10, text: val, createUser: uId },
          (obj) => {
            console.log("厅长信箱---", obj);
            if (obj.code == 200) {
              this.setState({
                listData: obj.data.records,
              });
            }
          }
        );

        break;
      case "2": //征求意见
        Http.get(
          Request.solicitopinionsLList(),
          { current: 1, size: 10, text: val, createUser: uId },
          (obj) => {
            console.log("征求意见---", obj);

            if (obj.code == 200) {
              this.setState({
                listData: obj.data.records,
              });
            }
          }
        );
        break;
      case "3": //网上征求意见信箱
        Http.get(
          Request.consultationmailboxLList(),
          { current: 1, size: 10, text: val, createUser: uId },
          (obj) => {
            console.log("网上征求意见信箱---", obj);

            if (obj.code == 200) {
              this.setState({
                listData: obj.data.records,
              });
            }
          }
        );
        break;
      case "4": //业务资讯
        Http.get(
          Request.businessconsultingLList(),
          { current: 1, size: 10, text: val, createUser: uId },
          (obj) => {
            console.log("业务资讯---", obj);

            if (obj.code == 200) {
              this.setState({
                listData: obj.data.records,
              });
            }
          }
        );
        break;
      default:
        Http.get(
          Request.directormailboxLList(),
          { current: 1, size: 10, text: val, createUser: uId },
          (obj) => {
            if (obj.code == 200) {
              this.setState({
                listData: obj.data.records,
              });
            }
          }
        );
        break;
    }
  }

  //点击渲染
  btnClick(e) {
    let index = e.target.dataset.tpye;
    this.setState({
      selectindex: e.target.dataset.tpye,
    });
    this.tosearch(index, "", this.state.userId);
  }

  //输入渲染
  onSearch = (value) => {
    const { selectindex, userId } = this.state;
    this.tosearch(selectindex, value, userId);
  };

  // 点击跳转
  viewDetail(text, url) {
    window.open(url + "?id=" + text.id);
  }
  onChange2(value) {
    this.setState({ value });
  }
  onChange3(key, value) {
    this.setState({
      form2: Object.assign({}, this.state.form2, { [key]: value }),
    });
  }

  render() {
    const {
      activekey,
      disabled,
      processes,
      details,
      dicts,
      isdetail,
      form,
      value1,
      value2,
      listData,
      visible,
      confirmLoading,
    } = this.state;
    // const　{form} = this.props
    const title = (
      <div>
        <img src={Edit} alt="" /> 请对本次服务进行评价
      </div>
    );
    const columns1 = [
      {
        label: "编号",
        prop: "idNumber",
        align: "center",
      },
      {
        label: "留言标题",
        prop: "messageTitle",
      },
      {
        label: "提交时间",
        prop: "createTime",
      },
      {
        label: "操作",
        render: (text, record) => (
          <div>
            <a
              onClick={() =>
                this.viewDetail(text, "/entrance/directorMailboxDetail")
              }
            >
              查看
            </a>
          </div>
        ),
      },
    ];
    const columns2 = [
      {
        label: "编号",
        prop: "idNumber",
        align: "center",
      },
      {
        label: "留言标题",
        prop: "title",
      },
      {
        label: "提交时间",
        prop: "createTime",
      },
      {
        label: "操作",
        render: (text, record) => (
          <div>
            <a
              onClick={() =>
                this.viewDetail(text, "/entrance/solicitOpinionsDetail")
              }
            >
              查看
            </a>
          </div>
        ),
      },
    ];
    const columns3 = [
      {
        label: "编号",
        prop: "idNumber",
        align: "center",
      },
      {
        label: "留言标题",
        prop: "title",
      },
      {
        label: "提交时间",
        prop: "createTime",
      },
      {
        label: "操作",
        render: (text, record) => (
          <div>
            <a
              onClick={() =>
                this.viewDetail(text, "/entrance/opinionsMailboxDetail")
              }
            >
              查看
            </a>
          </div>
        ),
      },
    ];
    const columns4 = [
      {
        label: "编号",
        prop: "idNumber",
        align: "center",
      },
      {
        label: "留言标题",
        prop: "messageTitle",
      },
      {
        label: "提交时间",
        prop: "createTime",
      },
      {
        label: "操作",
        render: (text, record) => (
          <div>
            <a
              onClick={() =>
                this.viewDetail(text, "/entrance/businessConsultingDetail")
              }
            >
              查看
            </a>
          </div>
        ),
      },
    ];
    const { selectindex } = this.state;
    let cols = {};
    switch (selectindex) {
      case "1":
        cols = columns1;
        break;
      case "2":
        cols = columns2;
        break;
      case "3":
        cols = columns3;

        break;
      case "4":
        cols = columns4;

        break;
      default:
        cols = columns1;
        break;
    }

    return (
      <div className="main-config">
        <Navigation />
        <div className="main-container">
          <div className="main-left">
            <div className="main-title">个人中心</div>
            <div
              className={
                activekey == "basic" ? "active main-subtitle" : "main-subtitle"
              }
              onClick={() => this.handleChange("basic")}
            >
              基本信息
            </div>
            <div
              className={
                activekey == "schedule"
                  ? "active main-subtitle"
                  : "main-subtitle"
              }
              onClick={() => this.handleChange("schedule")}
            >
              进度查询
            </div>
            <div
              className={
                activekey == "hudong" ? "active main-subtitle" : "main-subtitle"
              }
              onClick={() => this.handleChange("hudong")}
            >
              互动交流
            </div>
          </div>
          <div className="main-rigth">
            {activekey == "basic" ? (
              <Form
                ref="form"
                model={this.state.form}
                rules={this.state.rules}
                labelWidth="130"
              >
                <Row gutter={8}>
                  <Col sm={{ span: 24 }}>
                    <Form.Item label="头像" props="avatar" required={true}>
                      <Upload
                        disabled={disabled}
                        className={
                          disabled
                            ? `avatar-disabled avatar-uploader`
                            : `avatar-uploader`
                        }
                        action={
                          Request.getDebugUrl() +
                          "swsmart-file/fileServer/uploadSingle"
                        }
                        showFileList={false}
                        accept="image/jpg, image/jpeg, image/png"
                        onSuccess={(res, file) =>
                          this.handleAvatarScucess(res, file, "avatar")
                        }
                        beforeUpload={(file) => this.beforeAvatarUpload(file)}
                        tip={
                          <div className="el-upload__tip">
                            只能上传jpg/png/jpeg文件
                          </div>
                        }
                      >
                        {this.state.form.avatar ? (
                          <img
                            src={this.state.form.avatar}
                            className="avatar"
                            style={{ width: 145, height: 145 }}
                          />
                        ) : (
                          <i className="el-icon-plus avatar-uploader-icon"></i>
                        )}
                      </Upload>
                    </Form.Item>
                  </Col>
                  <Col sm={{ span: 12 }}>
                    <Form.Item label="姓名" props="name">
                      <Input
                        disabled
                        value={this.state.form.name}
                        onChange={this.onChange.bind(this, "name")}
                      ></Input>
                    </Form.Item>
                  </Col>
                  <Col sm={{ span: 12 }}>
                    <Form.Item
                      label="户口性质"
                      props="householdRegistrationNature"
                      required={true}
                    >
                      <Select
                        disabled={disabled}
                        value={
                          this.state.form.userVeterans
                            ? this.state.form.userVeterans
                                .householdRegistrationNature
                            : ""
                        }
                        placeholder="请选择"
                        onChange={this.onChange.bind(
                          this,
                          "householdRegistrationNature"
                        )}
                      >
                        <Select.Option
                          label="农业"
                          value="农业"
                        ></Select.Option>
                        <Select.Option
                          label="非农业"
                          value="非农业"
                        ></Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col sm={{ span: 12 }}>
                    <Form.Item label="性别" props="sexName">
                      <Input
                        disabled
                        value={this.state.form.sexName}
                        onChange={this.onChange.bind(this, "sexName")}
                      ></Input>
                    </Form.Item>
                  </Col>
                  <Col sm={{ span: 12 }}>
                    <Form.Item
                      label="户籍所在详细地址"
                      props="censusRegisterDetailedAddress"
                      required={true}
                    >
                      <Input
                        disabled={disabled}
                        value={
                          this.state.form.userVeterans
                            ? this.state.form.userVeterans
                                .censusRegisterDetailedAddress
                            : ""
                        }
                        onChange={this.onChange.bind(
                          this,
                          "censusRegisterDetailedAddress"
                        )}
                      ></Input>
                    </Form.Item>
                  </Col>
                  <Col sm={{ span: 12 }}>
                    <Form.Item label="年龄" props="age">
                      <Input
                        disabled
                        value={this.state.form.age}
                        onChange={this.onChange.bind(this, "age")}
                      ></Input>
                    </Form.Item>
                  </Col>
                  <Col sm={{ span: 12 }}>
                    <Form.Item
                      label="入伍时间"
                      props="enlistmentTime"
                      required={true}
                    >
                      <DatePicker
                        isDisabled={disabled}
                        value={value1}
                        // value={this.state.form.userVeterans ? this.state.form.userVeterans.enlistmentTime:''}
                        placeholder="选择日期"
                        // onChange={this.onChange.bind(this, 'enlistmentTime')}
                        onChange={(date) => {
                          this.setState({ value1: date });
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col sm={{ span: 12 }}>
                    <Form.Item label="手机号码" props="phone">
                      <Input
                        disabled
                        value={this.state.form.phone}
                        onChange={this.onChange.bind(this, "phone")}
                      ></Input>
                    </Form.Item>
                  </Col>
                  {/* <Col sm={{ span: 12 }}>
                      <Form.Item label="立功受奖情况" props="honorarytitle" required={true}>
                        <Select disabled={disabled} value={this.state.form.honorarytitle} placeholder="请选择" onChange={this.onChange.bind(this, 'honorarytitle')}>
                          <Select.Option label="荣誉称号" value="荣誉称号"></Select.Option>
                          <Select.Option label="一等功" value="一等功"></Select.Option>
                          <Select.Option label="二等功" value="二等功"></Select.Option>
                          <Select.Option label="三等功" value="三等功"></Select.Option>
                          <Select.Option label="优秀士官" value="优秀士官"></Select.Option>
                          <Select.Option label="优秀士兵" value="优秀士兵"></Select.Option>
                          <Select.Option label="嘉奖" value="嘉奖"></Select.Option>
                        </Select>
                      </Form.Item>
                    </Col> */}
                  <Col sm={{ span: 12 }}>
                    <Form.Item
                      label="退伍时间"
                      props="dischargeTime"
                      required={true}
                    >
                      <DatePicker
                        isDisabled={disabled}
                        value={value2}
                        // value={this.state.form.userVeterans ? this.state.form.userVeterans.dischargeTime:''}
                        placeholder="选择日期"
                        // onChange={this.onChange.bind(this, 'dischargeTime')}
                        onChange={(date) => {
                          this.setState({ value2: date });
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col sm={{ span: 12 }}>
                    <Form.Item
                      label="现状"
                      props="presentSituation"
                      required={true}
                    >
                      <Select
                        disabled={disabled}
                        value={
                          this.state.form.userVeterans
                            ? this.state.form.userVeterans.presentSituation
                            : ""
                        }
                        placeholder="请选择"
                        onChange={this.onChange.bind(this, "presentSituation")}
                      >
                        <Select.Option
                          label="在职在岗"
                          value="在职在岗"
                        ></Select.Option>
                        <Select.Option
                          label="社会创业"
                          value="社会创业"
                        ></Select.Option>
                        <Select.Option
                          label="回乡务农"
                          value="回乡务农"
                        ></Select.Option>
                        <Select.Option
                          label="公益性岗位"
                          value="公益性岗位"
                        ></Select.Option>
                        <Select.Option
                          label="离（退）休"
                          value="离（退）休"
                        ></Select.Option>
                        <Select.Option
                          label="城镇无业"
                          value="城镇无业"
                        ></Select.Option>
                        <Select.Option
                          label="其他"
                          value="其他"
                        ></Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col sm={{ span: 12 }}>
                    <Form.Item
                      label="从业类型"
                      props="employmentType"
                      required={true}
                    >
                      <Select
                        disabled={disabled}
                        value={
                          this.state.form.userVeterans
                            ? this.state.form.userVeterans.employmentType
                            : ""
                        }
                        placeholder="请选择"
                        onChange={this.onChange.bind(this, "employmentType")}
                      >
                        <Select.Option
                          label="机关单位"
                          value="机关单位"
                        ></Select.Option>
                        <Select.Option
                          label="事业单位"
                          value="事业单位"
                        ></Select.Option>
                        <Select.Option
                          label="国有企业"
                          value="国有企业"
                        ></Select.Option>
                        <Select.Option
                          label="私营企业"
                          value="私营企业"
                        ></Select.Option>
                        <Select.Option
                          label="个体经营"
                          value="个体经营"
                        ></Select.Option>
                        <Select.Option
                          label="外出打工"
                          value="外出打工"
                        ></Select.Option>
                        <Select.Option
                          label="公益性岗位"
                          value="公益性岗位"
                        ></Select.Option>
                        <Select.Option
                          label="其他"
                          value="其他"
                        ></Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col sm={{ span: 12 }}>
                    <Form.Item
                      label="人员类别"
                      props="personnelCategory"
                      required={true}
                    >
                      <Select
                        disabled={disabled}
                        value={
                          this.state.form.userVeterans
                            ? this.state.form.userVeterans.personnelCategory
                            : ""
                        }
                        placeholder="请选择"
                        onChange={this.onChange.bind(this, "personnelCategory")}
                      >
                        <Select.Option
                          label="士兵"
                          value="士兵"
                        ></Select.Option>
                        <Select.Option
                          label="干部"
                          value="干部"
                        ></Select.Option>
                        <Select.Option
                          label="优抚对象"
                          value="优抚对象"
                        ></Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  {form.userVeterans &&
                    form.userVeterans.personnelCategory &&
                    form.userVeterans.personnelCategory == "士兵" && (
                      <>
                        <Col sm={{ span: 12 }}>
                          <Form.Item
                            label="户籍类型"
                            props="householdRegistrationType"
                            required={true}
                          >
                            <Select
                              disabled={disabled}
                              value={
                                this.state.form.userVeterans
                                  ? this.state.form.userVeterans
                                      .householdRegistrationType
                                  : ""
                              }
                              placeholder="请选择"
                              onChange={this.onChange.bind(
                                this,
                                "householdRegistrationType"
                              )}
                            >
                              <Select.Option
                                label="农村籍"
                                value="农村籍"
                              ></Select.Option>
                              <Select.Option
                                label="城镇籍"
                                value="城镇籍"
                              ></Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col sm={{ span: 12 }}>
                          <Form.Item
                            label="退役兵类型"
                            props="retiredSoldiersTypes"
                            required={true}
                          >
                            <Select
                              disabled={disabled}
                              value={
                                this.state.form.userVeterans
                                  ? this.state.form.userVeterans
                                      .retiredSoldiersTypes
                                  : ""
                              }
                              placeholder="请选择"
                              onChange={this.onChange.bind(
                                this,
                                "retiredSoldiersTypes"
                              )}
                            >
                              <Select.Option
                                label="退役义务兵"
                                value="退役义务兵"
                              ></Select.Option>
                              <Select.Option
                                label="退役志愿兵"
                                value="退役志愿兵"
                              ></Select.Option>
                              <Select.Option
                                label="退役士官"
                                value="退役士官"
                              ></Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col sm={{ span: 12 }}>
                          <Form.Item
                            label="安置方式"
                            props="resettlementMode"
                            required={true}
                          >
                            <Select
                              disabled={disabled}
                              value={
                                this.state.form.userVeterans
                                  ? this.state.form.userVeterans
                                      .resettlementMode
                                  : ""
                              }
                              placeholder="请选择"
                              onChange={this.onChange.bind(
                                this,
                                "resettlementMode"
                              )}
                            >
                              <Select.Option
                                label="安排工作"
                                value="安排工作"
                              ></Select.Option>
                              <Select.Option
                                label="自主就业"
                                value="自主就业"
                              ></Select.Option>
                              <Select.Option
                                label="退休（从部队办理）"
                                value="退休（从部队办理）"
                              ></Select.Option>
                              <Select.Option
                                label="供养"
                                value="供养"
                              ></Select.Option>
                              <Select.Option
                                label="复员"
                                value="复员"
                              ></Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col sm={{ span: 12 }}>
                          <Form.Item
                            label="安置工作情况"
                            props="resettlementWork"
                            required={true}
                          >
                            <Select
                              disabled={disabled}
                              value={
                                this.state.form.userVeterans
                                  ? this.state.form.userVeterans
                                      .resettlementWork
                                  : ""
                              }
                              placeholder="请选择"
                              onChange={this.onChange.bind(
                                this,
                                "resettlementWork"
                              )}
                            >
                              <Select.Option
                                label="安排后在岗"
                                value="安排后在岗"
                              ></Select.Option>
                              <Select.Option
                                label="安排后下岗失业"
                                value="安排后下岗失业"
                              ></Select.Option>
                              <Select.Option
                                label="安排后未上岗"
                                value="安排后未上岗"
                              ></Select.Option>
                              <Select.Option
                                label="应安置未安置"
                                value="应安置未安置"
                              ></Select.Option>
                              <Select.Option
                                label="自谋职业"
                                value="自谋职业"
                              ></Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </>
                    )}
                  {form.userVeterans &&
                    form.userVeterans.personnelCategory &&
                    form.userVeterans.personnelCategory == "干部" && (
                      <>
                        <Col sm={{ span: 12 }}>
                          <Form.Item label="职级" props="rank" required={true}>
                            <Select
                              disabled={disabled}
                              value={
                                this.state.form.userVeterans
                                  ? this.state.form.userVeterans.rank
                                  : ""
                              }
                              placeholder="请选择"
                              onChange={this.onChange.bind(this, "rank")}
                            >
                              <Select.Option
                                label="排级"
                                value="排级"
                              ></Select.Option>
                              <Select.Option
                                label="连级"
                                value="连级"
                              ></Select.Option>
                              <Select.Option
                                label="营级"
                                value="营级"
                              ></Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col sm={{ span: 12 }}>
                          <Form.Item
                            label="安置方式"
                            props="resettlementMode"
                            required={true}
                          >
                            <Select
                              disabled={disabled}
                              value={
                                this.state.form.userVeterans
                                  ? this.state.form.userVeterans
                                      .resettlementMode
                                  : ""
                              }
                              placeholder="请选择"
                              onChange={this.onChange.bind(
                                this,
                                "resettlementMode"
                              )}
                            >
                              <Select.Option
                                label="计划分配"
                                value="计划分配"
                              ></Select.Option>
                              <Select.Option
                                label="自主择业"
                                value="自主择业"
                              ></Select.Option>
                              <Select.Option
                                label="企业军转干部"
                                value="企业军转干部"
                              ></Select.Option>
                              <Select.Option
                                label="复员军休干部"
                                value="复员军休干部"
                              ></Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                      </>
                    )}
                  {form.userVeterans &&
                    form.userVeterans.personnelCategory &&
                    form.userVeterans.personnelCategory == "优抚对象" && (
                      <>
                        <Col sm={{ span: 12 }}>
                          <Form.Item
                            label="是否优抚对象"
                            props="preferentialCareObject"
                            required={true}
                          >
                            <Select
                              disabled={disabled}
                              value={
                                this.state.form.userVeterans
                                  ? this.state.form.userVeterans
                                      .preferentialCareObject
                                  : ""
                              }
                              placeholder="请选择"
                              onChange={this.onChange.bind(
                                this,
                                "preferentialCareObject"
                              )}
                            >
                              <Select.Option
                                label="是"
                                value="是"
                              ></Select.Option>
                              <Select.Option
                                label="否"
                                value="否"
                              ></Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        {form.userVeterans &&
                          form.userVeterans.preferentialCareObject &&
                          form.userVeterans.preferentialCareObject == "是" && (
                            <Col sm={{ span: 12 }}>
                              <Form.Item
                                label="优抚对象类别"
                                props="preferentialCareObjectType"
                                required={true}
                              >
                                <Select
                                  disabled={disabled}
                                  value={
                                    this.state.form.userVeterans
                                      ? this.state.form.userVeterans
                                          .preferentialCareObjectType
                                      : ""
                                  }
                                  placeholder="请选择"
                                  onChange={this.onChange.bind(
                                    this,
                                    "preferentialCareObjectType"
                                  )}
                                >
                                  <Select.Option
                                    label="伤残人员 "
                                    value="伤残人员"
                                  ></Select.Option>
                                  <Select.Option
                                    label="在乡老复员军人"
                                    value="在乡老复员军人"
                                  ></Select.Option>
                                  <Select.Option
                                    label="带病回乡退伍军人"
                                    value="带病回乡退伍军人"
                                  ></Select.Option>
                                  <Select.Option
                                    label="参战退役人员"
                                    value="参战退役人员"
                                  ></Select.Option>
                                  <Select.Option
                                    label="参战（涉核）退役人员 "
                                    value="参战（涉核）退役人员"
                                  ></Select.Option>
                                  <Select.Option
                                    label="烈士老年子女"
                                    value="烈士老年子女"
                                  ></Select.Option>
                                  <Select.Option
                                    label="年满60周岁农村籍退役士兵"
                                    value="年满60周岁农村籍退役士兵"
                                  ></Select.Option>
                                  <Select.Option
                                    label="烈士遗属"
                                    value="烈士遗属"
                                  ></Select.Option>
                                  <Select.Option
                                    label="因公牺牲军人遗属"
                                    value="因公牺牲军人遗属"
                                  ></Select.Option>
                                  <Select.Option
                                    label="病故军人遗属"
                                    value="病故军人遗属"
                                  ></Select.Option>
                                  <Select.Option
                                    label="其他"
                                    value="其他"
                                  ></Select.Option>
                                </Select>
                              </Form.Item>
                            </Col>
                          )}
                      </>
                    )}
                </Row>
                <div className="form-footer">
                  <div
                    className="form-btn"
                    onClick={() => this.handleEdit(false)}
                  >
                    编辑
                  </div>
                  <div
                    className="form-btn"
                    onClick={this.handleSubmit.bind(this)}
                  >
                    保存
                  </div>
                </div>
              </Form>
            ) : activekey == "hudong" ? (
              <div className="box">
                <div className="mian">
                  <div className="topRow">
                    <div className="btn" onClick={this.btnClick.bind(this)}>
                      <div
                        className={
                          this.state.selectindex == "1"
                            ? "checkedBgn"
                            : "readbtn"
                        }
                        type={this.state.selectindex == "1" ? "primary" : ""}
                        data-tpye="1"
                      >
                        厅长信箱
                      </div>
                      <div
                        className={
                          this.state.selectindex == "2"
                            ? "checkedBgn"
                            : "readbtn"
                        }
                        type={this.state.selectindex == "2" ? "primary" : ""}
                        data-tpye="2"
                      >
                        征求意见
                      </div>
                      <div
                        className={
                          this.state.selectindex == "3"
                            ? "checkedBgn"
                            : "readbtn"
                        }
                        type={this.state.selectindex == "3" ? "primary" : ""}
                        data-tpye="3"
                      >
                        网上征求意见信箱
                      </div>
                      <div
                        className={
                          this.state.selectindex == "4"
                            ? "checkedBgn"
                            : "readbtn"
                        }
                        type={this.state.selectindex == "4" ? "primary" : ""}
                        data-tpye="4"
                      >
                        业务资讯
                      </div>
                    </div>
                    <div className="inputbox">
                      <Search
                        // rowKey=''
                        placeholder="请输入内容"
                        allowClear
                        enterButton="搜索"
                        onSearch={this.onSearch}
                        style={{ width: "320px" }}
                      />
                    </div>
                  </div>

                  <Table
                    columns={cols}
                    data={listData}
                    onChange={this.onChange}
                  />
                </div>
              </div>
            ) : (
              <div>
                {isdetail ? (
                  <Form
                    ref="form"
                    model={details}
                    labelWidth="80"
                    className="demo-ruleForm"
                  >
                    <Row gutter={8}>
                      <Col sm={{ span: 8 }}>
                        <Form.Item label="姓名" props="name">
                          <Input
                            placeholder="请输入"
                            value={details.name}
                            disabled={true}
                          ></Input>
                        </Form.Item>
                      </Col>
                      <Col sm={{ span: 8 }}>
                        <Form.Item label="身份证号" props="identityAccount">
                          <Input
                            placeholder="请输入"
                            value={details.identityAccount}
                            disabled={true}
                          ></Input>
                        </Form.Item>
                      </Col>
                      <Col sm={{ span: 8 }}>
                        <Form.Item label="性别" props="gender">
                          <Select
                            value={details.gender.toString()}
                            placeholder="请选择"
                            disabled={true}
                          >
                            <Select.Option label="男" value="1"></Select.Option>
                            <Select.Option label="女" value="2"></Select.Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col sm={{ span: 8 }}>
                        <Form.Item label="年龄" props="age">
                          <Input
                            placeholder="请输入"
                            value={details.age}
                            disabled={true}
                          ></Input>
                        </Form.Item>
                      </Col>
                      <Col sm={{ span: 8 }}>
                        <Form.Item label="联系电话" props="phone">
                          <Input
                            placeholder="请输入"
                            value={details.phone}
                            disabled={true}
                          ></Input>
                        </Form.Item>
                      </Col>
                      <Col sm={{ span: 8 }}>
                        <Form.Item label="民族" props="nation">
                          {/* <Input placeholder="请输入" value={details.nation} disabled={true}></Input> */}
                          <Select
                            value={details.nation}
                            placeholder="请选择"
                            disabled={true}
                          >
                            {dicts &&
                              dicts.length > 0 &&
                              dicts.map(function (item, i) {
                                if (item.code == "nation") {
                                  return item.children.map(function (r, j) {
                                    return (
                                      <Select.Option
                                        label={r.dictValue}
                                        value={r.dictValue}
                                      ></Select.Option>
                                    );
                                  });
                                }
                              })}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col sm={{ span: 24 }}>
                        <Form.Item label="标题" props="complaintTitle">
                          <Input
                            placeholder="请输入"
                            value={details.complaintTitle}
                            disabled={true}
                          ></Input>
                        </Form.Item>
                      </Col>
                      <Col sm={{ span: 24 }}>
                        <Form.Item label="类别" props="categoryId">
                          <Radio.Group value={details.categoryId}>
                            {dicts &&
                              dicts.length > 0 &&
                              dicts.map(function (item, i) {
                                if (item.code == "complaint") {
                                  return item.children.map(function (r, j) {
                                    return (
                                      <Radio value={r.id}>{r.dictValue}</Radio>
                                    );
                                  });
                                }
                              })}
                          </Radio.Group>
                        </Form.Item>
                      </Col>
                      <Col sm={{ span: 24 }}>
                        <Form.Item
                          label="反应投诉建议详细情况：请勿填写泄露后可能损害国家在政治、经济、国防、外交等领域涉及国家安全和利益的事项。"
                          props="category"
                          className="input-textarea"
                        >
                          <Input
                            type="textarea"
                            // autosize={{ minRows: 1, maxRows: 5 }}
                            rows={5}
                            disabled={true}
                            value={details.complaintContent}
                            placeholder="请勿填写原部队情况和所参加任务的详情信息，可简要填写反馈问题发生的时间、地点、事情经过和结果以及退役后所在的工作单位、工作现状等内容"
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form>
                ) : (
                  <Table
                    style={{ width: "100%" }}
                    columns={this.state.columns}
                    data={processes}
                    border={true}
                    height={450}
                  />
                )}
              </div>
            )}
          </div>
        </div>
        <div>
          <Modal
            title={title}
            visible={visible}
            width={845}
            onOk={this.handleOk}
            confirmLoading={confirmLoading}
            onCancel={this.handleCancel}
            okText={"确定"}
            cancelText={"取消"}
            destroyOnClose
          >
            <Form
              ref="form2"
              model={this.state.form2}
              rules={this.state.rules2}
            >
              <Row gutter={24}>
                <Col span={24}>
                  <Form.Item
                    label="评价等级"
                    className="selfRate"
                    required={true}
                    props="applicantEvaluation"
                  >
                    <Rate
                      showText={true}
                      texts={[
                        "非常不满意",
                        "不满意",
                        "基本满意",
                        "满意",
                        "非常满意",
                      ]}
                      onChange={this.onChange3.bind(
                        this,
                        "applicantEvaluation"
                      )}
                      style={{ lineHeight: "40px" }}
                    />
                  </Form.Item>

                  <Form.Item
                    label=""
                    className="selfRate"
                    required={true}
                    props="applicantScore"
                  >
                    <TextArea
                      rows={4}
                      placeholder="请输入其他评价"
                      onChange={this.onChange3.bind(this, "applicantScore")}
                    />
                  </Form.Item>
                  <Form.Item
                    label=""
                    required={true}
                    props="applicantEvaluationExhibitionMode"
                  >
                    <div>
                      <Radio
                        value="1"
                        checked={this.state.value === 1}
                        onChange={this.onChange3.bind(
                          this,
                          "applicantEvaluationExhibitionMode"
                        )}
                      >
                        匿名
                      </Radio>
                      <Radio
                        value="2"
                        checked={this.state.value === 2}
                        onChange={this.onChange3.bind(
                          this,
                          "applicantEvaluationExhibitionMode"
                        )}
                      >
                        公开
                      </Radio>
                    </div>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Modal>
        </div>
      </div>
    );
  }
}
